import { VIEWER_PAGE_EXTENSION } from "../../../helpers/constants/Constants";

const modelViewer = {
  key: "model-viewer",
  title: "Model Viewer",
  angle: 90,
  summary: "An interactive 3D model viewer for all teams on all projects.",
  releaseDate: "Released (next version late 2026)",
  launch: VIEWER_PAGE_EXTENSION,
  planStages: [
    {
      name: "Markup Enhancements",
      detail: [
        {
          text: "Multiple markups from different users",
          checked: false,
        },
        "Visual pins for each markup on model",
        "Edit own markup functionality post creation",
        "Zoom on 2D markups",
        "Save markups before publishing",
        "Markup filter enhancements",
        "Markup comparison enhancements",
        "Enhanced markups (rotate, scale, move, etc.)",
      ],
      completionDate: "Sep 26",
    },
    {
      name: "Model Capabilities",
      detail: [
        {
          text: "View saving and sharing capability",
          checked: false,
        },
        "Section saving and sharing capability",
      ],
      completionDate: "Oct 26",
    },
    {
      name: "General Enhancements",
      detail: [
        {
          text: "Edit model configuration and settings post initial setup",
          checked: false,
        },
        {
          text: "Timeout extended before model viewer session expires",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "CAD Integration",
      detail: [
        {
          text: "Prevent users repeating model names",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Training and Support",
      detail: [
        {
          text: "Provide area for hints and best practices",
          checked: false,
        },
        "Training Academy startup",
      ],
      completionDate: "Nov 26",
    },
  ],
  points: [
    "Explore models with automatic federation",
    "Pass models through ISO 19650-compliant workflows",
    "Investigate issues with context-rich overlays and data",
    "Collaborate with teams in real-time",
    "Markup and annotate models with comments, tags and photos",
  ],
};

export default modelViewer;
